<template>
  <v-select
    label="Razón Social"
    placeholder="seleccione la razón social"
    :loading="loading"
    :items="items"
    item-text="name"
    :item-value="returnId ? 'id' : 'branch_offices'"
    :rules="onlyRequired"
    v-bind:value="value"
    v-on:input="$emit('input', $event)"
    :return-object="returnObj ? true : false"
    ref="auto"
  ></v-select>
</template>

<script>
import requests from "@/services/requests";
import rules from "@/utils/form.rules";

export default {
  props: {
    value: [Number, Array, String, Object],
    returnId: { type: Boolean, default: false },
    returnObj: { type: Boolean, default: false },
    reset: { type: Boolean },
  },
  data: () => ({
    items: [],
    loading: false,
    onlyRequired: [rules.required],
  }),
  mounted() {
    this.loadItems();
  },
  methods: {
    loadItems() {
      this.loading = true;
      requests.get("api/catalogs/businessname").then((response) => {
        if (response.status == 200) {
          this.items = response.data;
        } else {
          console.log(response);
        }
        this.loading = false;
      });
    },
  },
  watch: {
    reset: function () {
      this.$refs.auto.reset();
    },
  },
};
</script>
